import { axiosInstance } from '../api';

export default function(email, password, rememberMe) {
    return axiosInstance.post('/api/auth/login', {
        'username': email,
        'password': password,
        'rememberMe': rememberMe
    });
}